import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "slot-before d-flex align-items-center justify-content-center" }
const _hoisted_2 = ["id", "disabled", "type", "value", "placeholder"]
const _hoisted_3 = { class: "slot-after d-flex align-items-center justify-content-center" }

import { reactive } from 'vue'
import ContainerBox from '@/components/LoginRegister/common/ContainerBox/v1/ContainerBox.vue'

interface Props {
    id?: string
    value: string
    disabled?: boolean
    placeholder?: string
    upperInscriptionBackground?: string
    inputStyles?: { [key: string]: string }
    containerBoxBorder?: string
    containerBorderRadius?: string
    inputType?: string,
    allowedType?: "number" | "text"
}
interface Emits {
    (e: 'change', value: string): void
    (e: 'input', value: string): void
}

// state

export default /*@__PURE__*/_defineComponent({
  __name: 'Text',
  props: {
    id: {},
    value: { default: "" },
    disabled: { type: Boolean },
    placeholder: {},
    upperInscriptionBackground: {},
    inputStyles: {},
    containerBoxBorder: {},
    containerBorderRadius: {},
    inputType: {},
    allowedType: {}
  },
  emits: ["change", "input"],
  setup(__props: any, { emit: __emit }) {

const state = reactive({
    isFocused: false,
})

// props
const props = __props

// emit
const emit = __emit

// handlers
// handlers
const handleInput = (e: InputEvent) => {
    if (props.disabled) return
    const inputElement = e.target as HTMLInputElement;
    let inputValue = inputElement.value;

    // Conditionally filter input based on allowedType
    if (props.allowedType === 'number') {
        // Replace non-numeric characters to enforce numeric input
        inputValue = inputValue.replace(/\D/g, '');
        inputElement.value = inputValue;  // Set the sanitized value back to the input
    }

    emit('input', inputValue);
}

const handleChange = (e: InputEvent) => {
    if (props.disabled) return
    emit('change', e.target.value)
}
const handleFocus = (e: InputEvent) => {
    if (props.disabled) return
    state.isFocused = true
}
const handleBlur = (e: InputEvent) => {
    state.isFocused = false
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["position-relative main-wrapper", props.disabled && 'disabled'])
  }, [
    _createVNode(ContainerBox, {
      ref: "input-container",
      border: _ctx.containerBoxBorder,
      borderRadius: _ctx.containerBorderRadius,
      class: "container-wrapper",
      active: state.isFocused
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _renderSlot(_ctx.$slots, "before")
        ]),
        _createElementVNode("input", {
          id: props.id,
          disabled: props.disabled,
          ref: "input",
          onInput: _cache[0] || (_cache[0] = (e) => handleInput(e)),
          onChange: _cache[1] || (_cache[1] = (e) => handleChange(e)),
          onFocus: _cache[2] || (_cache[2] = (e) => handleFocus(e)),
          onBlur: _cache[3] || (_cache[3] = (e) => handleBlur(e)),
          class: "main-input form-control shadow-none no-autofill",
          type: props.inputType ?? 'text',
          value: props.value,
          placeholder: state.isFocused ? '' : props.placeholder,
          style: _normalizeStyle([{"border":"none","padding":"15px 25px"}, props.inputStyles])
        }, null, 44, _hoisted_2),
        _createElementVNode("div", _hoisted_3, [
          _renderSlot(_ctx.$slots, "after")
        ])
      ]),
      _: 3
    }, 8, ["border", "borderRadius", "active"]),
    (state.isFocused || props.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "upper-inscription bg-primary-white text-blue-800",
          style: _normalizeStyle({ background: props.upperInscriptionBackground })
        }, _toDisplayString(props.placeholder), 5))
      : _createCommentVNode("", true)
  ], 2))
}
}

})